import type { GetMeResponseDto } from "@/spz-api/model";
import type { CompanyPermission, GlobalPermission } from "@spz/shared-domain";

export const useHasGlobalPermission = (
  permissionName: GlobalPermission,
  user: GetMeResponseDto | undefined,
): boolean => {
  return useHasPermission(permissionName, user);
};

export const useHasCompanyPermission = (
  permissionName: CompanyPermission,
  user: GetMeResponseDto | undefined,
  companyId: string,
): boolean => {
  return useHasPermission(permissionName, user, companyId);
};

const useHasPermission = (
  permissionName: GlobalPermission | CompanyPermission,
  user: GetMeResponseDto | undefined,
  companyId?: string,
): boolean => {
  if (!user) return false;

  const { permissions, isAdmin } = user;

  if (isAdmin) return true;

  if (!permissions) return false;

  if (companyId) {
    return (permissions.byCompany[companyId] ?? []).includes(
      permissionName as CompanyPermission,
    );
  }

  return permissions.global.includes(permissionName as GlobalPermission);
};
